var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<ul class=\"store-details\">\n<li ng-if=\"$ctrl.showName\"><b>{{$ctrl.company.name}}</b></li>\n<li ng-bind-html=\"$ctrl.company.address | address_multi_line\"></li>\n<li ng-show=\"$ctrl.company.address.phone\">\n<i class=\"fa fa-phone\" aria-hidden=\"true\">\n</i>\n{{$ctrl.company.address.phone | local_phone_number}}\n</li>\n<li ng-show=\"$ctrl.company.distance != 0\">\n<i class=\"fa fa-location-arrow\" aria-hidden=\"true\">\n</i>\n<span class=\"distance\">{{$ctrl.company.distance | distance:1}}</span>\n</li>\n</ul>\n</div>\n";
var id1="public-booking/company-details/company_details.component.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/public-booking/company-details/company_details.component.html
// module id = 1218
// module chunks = 0